import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Courses from './pages/Courses';
import About from './pages/About';
import Results from './pages/Results';
import Contact from './pages/Contact';
import CourseDetail from './pages/CourseDetail';
import DemoLecture from './pages/DemoLecture';
import ScrollToTop from "./ScrollToTop"; 

/* ----------  ADMIN  ---------- */
import AdminLogin from './admin/AdminLogin';
import AdminDashboard from './admin/AdminDashboard';
import ProtectedAdmin from './admin/ProtectedAdmin';
import CoursesAdmin from './admin/CoursesAdmin';
// import BannersAdmin from './admin/BannersAdmin';
// import ResultsAdmin from './admin/ResultsAdmin';
// import TestimonialsAdmin from './admin/TestimonialsAdmin';
import { Navigate } from 'react-router-dom';

function App() {
  return (
    <Router>
        <ScrollToTop /> 
      <div className="min-h-screen flex flex-col">
        {/* Public header */}
        <Routes>
          <Route
            path="/*"
            element={
              <>
                <Navbar />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/courses" element={<Courses />} />
                    <Route path="/courses/:id" element={<CourseDetail />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/results" element={<Results />} />
                    <Route path="/contact" element={<Contact />} /> 
                    <Route path="/demolecture" element={<DemoLecture />} />
                  </Routes>
                </main>
                <Footer />
              </>
            }
          />

          {/* ----------  ADMIN  ---------- */}
          <Route path="/admin" element={<AdminLogin />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedAdmin>
                <AdminDashboard />
              </ProtectedAdmin>
            }
          >
           {/*  <Route index element={<Navigate to="courses" />} />
            <Route path="courses" element={<CoursesAdmin />} />
            <Route path="banners" element={<BannersAdmin />} />
            <Route path="results" element={<ResultsAdmin />} />
            <Route path="testimonials" element={<TestimonialsAdmin />} /> */}
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;